<template>
  <div class="page coupon-index">
    <navigation>我的券包</navigation>
    <van-tabs
      v-model="active"
      color="#333333"
      line-width="84"
      line-height="4"
      title-active-color="#333333"
      title-inactive-color="#BBBBBB"
      :sticky="false"
      @change="changeTab"
      :offset-top="128"
    >

      <van-tab title="红包">
        <div class="coupon-list" v-if="redpacketList.length > 0">
          <quan-item  v-for="(item,index) in redpacketList" :key="index"
                      :description="getPacketDescription(item)"
                      :rightDescription="getPacketRightDescription(item)"
                      :type="getPacketType(item)"
                      :amount="getDiscountValue(item)"
                      :validTime="getValidTimeDesc(item)"
                      :intrestDay="getPacketIntrestDesc(item)"
                      @click="goDetail(item)"
                      :unit="getPacketUnit(item)"
                      :useType="useType(item)"
          >
          </quan-item>
        </div>

        <section v-if="redpacketList.length === 0"  class="no-data">
          <img src="./images/quan_empty.png">
          <div class="tips">这里空空如也...</div>
          <div class="sub-tips">积累更多信用，赚取更多优惠吧</div>
        </section>
      </van-tab>

      <van-tab title="优惠券">
        <div class="coupon-list" v-if="couponList.length > 0">
          <nd-item  v-for="(item,index) in couponList"
                    :key="index"
                    :index="index"
                    :activeType="getPacketDescription(item)"
                    :couponType="getPacketType(item)"
                    :endTime="getValidTimeDesc(item)"
                    :money="getDiscountValue(item)"
                    :datail="item.couponDesc"
                    :showSelect="false"
                    :unit="getPacketUnit(item)"
                    color="red"
                    @goDetail="goDetail(item)"
                    :isClick="true"
                    :useType="useType(item)"
                    fontColor='black'
          >
          </nd-item>
        </div>
        <section v-if="couponList.length === 0" class="no-data">
          <img src="./images/quan_empty.png">
          <div class="tips">这里空空如也...</div>
          <div class="sub-tips">积累更多信用，赚取更多优惠吧</div>
        </section>
      </van-tab>
    </van-tabs>

    <div class="bottom-area">
      <div class="history" @click="goHistory">
        查看历史优惠
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant'
import quanItem from './components/quan-item.vue'
import { mapActions } from 'vuex'

export default {
  name: 'quan-list',
  customReadyNotify: true,
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs,
    'quan-item': quanItem
  },

  description: '券包列表',

  data () {
    return {
      active: 0,
      redpacketList: [],
      couponList: []
    }
  },

  async created () {
    await this.getCouponList()
    this.$bus.$emit('ready')
  },

  computed: {

  },

  methods: {
    ...mapActions('activities', [
      'couponListX'
    ]),
    // 切换tab
    changeTab (index) {
      this.$report({
        id: 10060,
        args: { position: index }
      })
    },
    // 卡类型
    useType (item) {
      if (item.memberGoodsGroupCd) {
        return item.useLimitDesc
      } else {
        return ''
      }
    },
    async getCouponList () {
      const res = await this.couponListX({
      })
      if (res.success) {
        let data = res.data || []
        this.redpacketList = data.filter(item => ['CASH', 'COUPON', 'REFUSE_PAY_PASSIVE'].includes(item.couponType))
        this.couponList = data.filter(item => ['LIMIT', 'RIGHTS_INTERESTS', 'SVIP_RIGHTS_INTERESTS'].includes(item.couponType))
      }
    },

    getPacketDescription (item) {
      const { activeType, memberCouponDesc } = item
      if (memberCouponDesc) {
        return memberCouponDesc
      } else if (activeType === 'NEW_PERSON') {
        return '天美贷新用户专享活动'
      } else if (activeType === 'PAY_IF_REFUSE_NEW') {
        return '天美贷拒就赔活动'
      } else if (activeType === 'REDUCTION_INTEREST') {
        return '天美贷免息红包活动'
      } else if (activeType === 'PERSON_REPEAT_LOAN') {
        return '天美贷新春赠礼活动'
      } else if (activeType === 'DRAINAGE') {
        return '天美贷引流活动'
      } else if (activeType === 'XIAOMEI_VIP') {
        return 'VIP会员'
      }
    },

    getPacketRightDescription (item) {
      return item.desc || ''
    },

    getPacketType (item) {
      const { couponType, activeType, memberGoodsGroupCd, supportMemberGoodsName } = item
      // REDUCTION_INTEREST 实际现金红包 但是 要显示为免息红包
      if (couponType === 'COUPON' || activeType === 'REDUCTION_INTEREST' || activeType === 'PERSON_REPEAT_LOAN') {
        return '免息红包'
      } else if (couponType === 'CASH') {
        if (activeType === 'XIAOMEI_VIP') {
          return '拒就赔现金红包'
        } else {
          return '现金红包'
        }
      } else if (couponType === 'LIMIT') {
        return '专享提额券'
      } else if (couponType === 'REFUSE_PAY_PASSIVE') {
        return '拒就赔现金红包'
      } else if (couponType === 'RIGHTS_INTERESTS') {
        if (memberGoodsGroupCd === 'SVIP') {
          return 'SVIP优惠券'
        } else {
          return supportMemberGoodsName ? supportMemberGoodsName + '优惠券' : 'VIP优惠券'
        }
      }
    },

    getDiscountValue (item) {
      if (!item.discountAmt) {
        return ''
      } else {
        if (item.discountAmt <= 1 && item.discountWay === 'RATIO') {
          return (item.discountAmt * 10).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
        } else {
          return Number(item.discountAmt).toFixed(2)
        }
      }
    },

    // getValidTimeDesc (item) {
    //   const { activeType, endTime, couponType } = item
    //   if (activeType === 'XIAOMEI_VIP') {
    //     if (couponType === 'CASH') {
    //       return `红包有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
    //     } else {
    //       return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
    //     }
    //   } else if (endTime) {
    //     if (activeType === 'PAY_IF_REFUSE_NEW' || ['RIGHTS_INTERESTS', 'SVIP_RIGHTS_INTERESTS'].includes(couponType)) {
    //       return `红包有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
    //     } else {
    //       return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
    //     }
    //   }
    // },

    getValidTimeDesc (item) {
      const { activeType, endTime, couponType, memberGoodsGroupCd } = item
      if (!endTime) return ''
      if ((activeType === 'XIAOMEI_VIP' && ['CASH', 'REFUSE_PAY_PASSIVE'].includes(couponType)) || memberGoodsGroupCd === 'KING') {
        return `有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      } else {
        return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD hh:mm:ss')}`
      }
    },

    getPacketIntrestDesc (item) {
      const { discountValue, activeType, discountLimitAmt, freeDiscountWay } = item
      if (activeType === 'REDUCTION_INTEREST') {
        return `免息${discountValue}天`
      } else {
        if (!['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(activeType)) {
          if (freeDiscountWay === 'DAYS') {
            return `免息${discountLimitAmt}天`
          } else if (freeDiscountWay === 'REBATE') {
            return `免息${discountLimitAmt * 10}折`
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },

    getPacketUnit (item) {
      if (['NEW_PERSON', 'PAY_IF_REFUSE_NEW', 'REDUCTION_INTEREST', 'PERSON_REPEAT_LOAN', 'DRAINAGE', 'NEW_PERSON'].includes(item.activeType)) {
        return '元'
      } else if (item.discountAmt <= 1 && item.discountWay === 'RATIO') {
        return '折'
      } else {
        return `元`
      }
      // if (item.discountType === 'DAILY') {
      //     return `天`
      // } else if (item.discountType === 'AMOUNT') {
      //     return '元'
      // } else {
      //     return ''
      // }
    },

    goDetail (item) {
      this.$report({
        id: 10143,
        args: {
          'status': item.status === 'RECEIVED' ? 1 : 0,
          'target': item.couponDetailId,
          'position': item.activeId
        }
      })
      this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
    },

    goHistory () {
      this.$report({
        id: 10144
      })
      this.$router.push('/quan/history')
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.page.coupon-index {
    background-color: #fafafa;
    position: relative;
    .coupon-list{
        overflow: scroll;
        padding-bottom: 170px;
    }
    .no-data {
        width: 100%;
        text-align: center;
        overflow: hidden;
        position: absolute;

        img {
            width: 205px;
            height: 173px;
            margin-top: 263px;
        }

        .tips {
            font-size:28px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:36px;
            margin-top: 37px;
        }

        .sub-tips {
          font-size:24px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:36px;
            margin-top: 5px;
        }
    }

     .van-tabs--line .van-tabs__wrap {
    height: 98px;
  }
  .van-tab {
    font-size: 36px;
    height: 98px;
    line-height: 98px;
  }
  .van-tab__text1 {
    height: 98px;
  }
    .van-ellipsis {
      margin-top: 23px;
      font-size:36px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      line-height:50px;
    }
    .repacket-list {
      padding-bottom: 180px;
    }
    .bottom-area {
        width: 750px;
        margin-left: -375px;
        height: 160px;
        background-color: #FAFAFA;
        position: fixed;
        bottom: 0;
        left: 50%;
        text-align: center;
        .history {
          margin-top: 10px;
          font-size:28px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color: #999999;
          line-height:40px;
        }
      }
}
</style>
